export default __webpack_public_path__ + "media/images/internal-error-2550x1700-bfc7f0b5065ab7db2e7dfc88d484da6d.jpg";